import { Component, Input, Output, EventEmitter } from '@angular/core';
import { UtilityService } from '../../core/services/utility.service';

@Component({
  selector: 'app-adjunto-card',
  templateUrl: './adjunto-card.component.html',
  styleUrls: ['./adjunto-card.component.scss']
})
export class AdjuntoCardComponent {

  @Input() tipo: any;
  @Input() isDragging: boolean = false;
  @Input() currentUploadingTipo: string = '';

  @Output() fileSelected = new EventEmitter<{ event: any, tipo: any }>();
  @Output() verArchivo = new EventEmitter<string>();
  @Output() eliminarArchivo = new EventEmitter<any>();
  @Output() validarDocumento = new EventEmitter<any>();
  @Output() dragOver = new EventEmitter<{ event: DragEvent, tipoId: string }>();
  @Output() dragLeave = new EventEmitter<DragEvent>();
  @Output() drop = new EventEmitter<{ event: DragEvent, tipo: any }>();

  constructor(public utility: UtilityService) {}

  onFileSelected(event: any) {
    this.fileSelected.emit({ event, tipo: this.tipo });
  }

  onVerArchivo() {
    if (this.tipo.archivo_url) {
      this.verArchivo.emit(this.tipo.archivo_url);
    }
  }

  onEliminarArchivo() {
    this.eliminarArchivo.emit(this.tipo);
  }

  onValidarDocumento() {
    this.validarDocumento.emit(this.tipo);
  }

  onDragOver(event: DragEvent) {
    this.dragOver.emit({ event, tipoId: this.tipo.id });
  }

  onDragLeave(event: DragEvent) {
    this.dragLeave.emit(event);
  }

  onDrop(event: DragEvent) {
    this.drop.emit({ event, tipo: this.tipo });
  }
}
